module.exports = __webpack_public_path__ + "img/librarytop.5d7a4a21.jpg";